export const getMyLearningUrl = (startDate, monthNumber) => {
  const year = new Date(startDate).getFullYear();
  const semester = monthNumber <= 6 ? 'spring' : 'autumn';
  return `/my-learning/${year}/${semester}?month=${monthNumber}`;
};
